import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { gridContainer } from "constants/styles";

const FEATURES = {
  TAX: "tax",
  CUSTOMER: "customer",
  PRE_POST: "pre_post",
  ANALYTICS: "analytics",
  AUTHORIZE: "authorize",
  CHURN: "churn"
};

const DOCS_GRID_CONFIG = [
  {
    id: FEATURES.TAX,
    label: "Automatic taxes",
    description:
      "Enable automatic calculation and collection of sales tax, VAT, and GST within checkout, as well as capturing and validating tax ids."
  },
  {
    id: FEATURES.CUSTOMER,
    label: "Customer lookup",
    description:
      "No more duplicate customer creation when using the same email. Simply pass your customer's email as a parameter, and we'll dynamically look them up in your Stripe account."
  },
  {
    id: FEATURES.PRE_POST,
    label: "Pre and post checkout",
    description:
      "Control where your customers get redirected to after checkout as well as deliver digital content after a successful purchase.",
    footer: "Additional custom pre-checkout fields coming soon."
  },
  {
    id: FEATURES.AUTHORIZE,
    label: "Authorize only",
    description:
      "Place a hold on the funds when the customer authorizes the payment, but don’t capture the funds until later."
  },
  {
    id: FEATURES.CHURN,
    label: "Prevent churn",
    description:
      "Don't let expired payment details result in failed payments. Send your customers a setup payment details link, to make it easy for them to add a new card on file."
  },
  {
    id: FEATURES.ANALYTICS,
    label: "Analytics",
    description:
      "Track the performance of your payment links with auto generated conversion funnels and other summary metrics."
  }
];

const FeatureGrid = () => {
  return (
    <div className="w-100">
      <div className="grid-container-2xl pt3">
        {DOCS_GRID_CONFIG.map(
          ({ Icon, label, description, callout, footer }, gridIx) => {
            return (
              <div className="w-100 pb3 pb0-ns" key={gridIx}>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center w-100">
                    {Icon && <Icon size={20} color={COLORS.primary} />}
                    <div
                      className={classnames(
                        "f4 f3-l fw6 color-text--primary lh-title",
                        {
                          pl2: Icon
                        }
                      )}
                      style={{ marginTop: 2 }}
                    >
                      {label}
                    </div>
                  </div>
                  {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
                </div>
                <div className="f5 f4-l lh-copy pt2 mt1 color-text--primary">
                  {description}
                </div>
                {footer && <div className="pt2">{footer}</div>}
              </div>
            );
          }
        )}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
      </div>
    </div>
  );
};

export default FeatureGrid;
